import React, { useEffect, useState, useRef } from "react";
import logo from "../assets/logo.png";
import styles from "./SplashScreen.module.css";


interface SplashScreenProps {
  controlled?: boolean;
  mode?: "reveal" | "instant";
}

const SplashScreen: React.FC<SplashScreenProps> = ({
  controlled = true,
  mode = "reveal",
}) => {
  const [hidden, setHidden] = useState(false);
  const [hideStripes, setHideStripes] = useState(false);
  const logoRef = useRef<HTMLImageElement>(null);


  useEffect(() => {
    if (mode === "instant") {
      setHideStripes(true);
    } else {
      setHideStripes(false);
    }
  }, [mode]);

  useEffect(() => {
 
    if (mode === "instant") return;

    const img = logoRef.current;
    if (!img) return;

    const onRevealEnd = () => {
      setHideStripes(true);

      if (!controlled) {
        const t = setTimeout(() => setHidden(true), 1500);
        return () => clearTimeout(t);
      }
    };

    img.addEventListener("animationend", onRevealEnd);
    return () => img.removeEventListener("animationend", onRevealEnd);
  }, [controlled, mode]);

  return (
    <div
      className={[
        styles.splash,
        hidden ? styles.splashHidden : "",
        mode === "instant" ? styles.modeInstant : styles.modeReveal,
      ].join(" ")}
    >
      <div className={styles.logoContainer}>
        <img
          ref={logoRef}
          src={logo}
          alt="Avila Projekt Management"
          className={styles.logo}
        />
        <div
          className={`${styles.stripes} ${
            hideStripes ? styles.stripesHidden : ""
          }`}
        />
      </div>
    </div>
  );
};

export default SplashScreen;
